module.exports = __webpack_public_path__ + "media/images/ac_templates/201/klyht-82c742d057bdc43f13657be64f2832d4.jpg";